const $ = require('jquery');
const _ = require('lodash');

module.exports = {
  init() {
    $(document).on('click', '.banner-close', function (e) {
      const bannerName = $(this).data('bannerName');
      $.get(`${_.get(globals, 'apiWebroot', '/')}banners/hide/${bannerName}`);
    });
  },
};
